import dashboardservice from "@/services/dashboardservice";

export const namespaced = true;

export const state = {
  lresults: [],
  scheadded: false,
  upschedules: [],
  pastschedules: [],
  mlresults: [],
  overallgraph: [],
  subjectgraph: {},
  leaderObj: [],
  leaderIObj: [],
  profileupdated: false,
  donelresults: false,
  upschedulesfetched: false,
  pastschedulesfetched: false,
  overallgraphfetched: false,
  subjectgraphfetched: false,
  miniresultfetched: false,
  maxiresultfetched: false,
  allorgspaces: {
    data: [],
    count: 0
  },
  orgspacesfetched: false,
  singletestspace: {},
  premiumplans: [],
  unset: false,
  ambstat: [],
  ambupdated: false,
  payoutrequested: false,
  usermetrics: [],
  fetchingpp: false,
  referrals: [],
  notifications: [],
  appLandingVisited: false
};

export const mutations = {
  SET_MINI_RESULTS(state, results) {
    state.donelresults = true;
    state.lresults = results;
    state.miniresultfetched = true;
  },
  SET_MAXI_RESULTS(state, results) {
    state.mlresults = results;
    state.maxiresultfetched = true;
  },
  SET_SCHEDULE_ADDED(state) {
    state.scheadded = true;
  },
  SET_UP_SCHEDULES(state, schedules) {
    state.upschedulesfetched = true;
    state.upschedules = schedules;
  },
  SET_PAST_SCHEDULES(state, schedules) {
    state.pastschedules = schedules;
    state.pastschedulesfetched = true;
  },
  SET_OVERALL_GRAPH(state, graphdata) {
    state.overallgraph = [];
    state.overallgraph.push(graphdata);
    state.overallgraphfetched = true;
  },
  SET_SUBJECT_GRAPH(state, graphdata) {
    state.subjectgraph = graphdata;
    state.subjectgraphfetched = true;
  },
  SET_LEADERBOARD(state) {
    state.leaderObj = [];
  },
  SET_LEADERBOARDI(state, leaderboard) {
    let initL = new Array();

    for (let leaderforsort of leaderboard) {
      //console.log(leaderforsort)
      let sortedLBoard = leaderforsort.sort(
        (a, b) => parseFloat(b.total_score) - parseFloat(a.total_score)
      );
      //console.log(sortedLBoard)
      initL.push(sortedLBoard);
      //console.log(initL)

      //console.log(state.leaderIObj)
    }

    state.leaderIObj = initL;
  },
  SET_PROFILE_UPDATED(state) {
    state.profileupdated = true;
  },
  EMPTY_MAXI_RESULT(state) {
    state.mlresults = [];
    state.maxiresultfetched = false;
  },
  EMPTY_MINI_RESULT(state) {
    state.miniresultfetched = false;
    state.miniresultfetched = [];
  },
  SET_ORGANIZATION_SPACES(state, orgspace) {
    state.orgspacesfetched = true;
    state.allorgspaces = orgspace;
  },
  SET_SINGLE_TEST_SPACE(state, data) {
    state.singletestspace = data;
  },
  SET_PREMIUM_PLANS(state, data) {
    state.premiumplans = data;
  },
  SET_UNSET(state) {
    state.unset = true;
  },
  AMB_STAT(state, data) {
    state.ambstat = data;
  },
  AMB_UPDATED(state) {
    state.ambupdated = true;
  },
  PAYOUT_REQUESTED(state) {
    state.payoutrequested = true;
  },
  USER_METRICS_FULL(state, data) {
    state.usermetrics = data;
  },
  FETCHINGPP(state) {
    state.fetchingpp = !state.fetchingpp;
  },
  SET_REFERRALS(state, data) {
    state.referrals = data;
  },
  SET_NOTIFICATIONS(state, data) {
    state.notifications = data;
  },

  SET_APP_LANDING_VISIT(state) {
    state.appLandingVisited = true;
  },

  DESTROY_ALL(state) {
    (state.lresults = []),
      (state.scheadded = false),
      (state.upschedules = []),
      (state.pastschedules = []),
      (state.mlresults = []),
      (state.overallgraph = []),
      (state.subjectgraph = {}),
      (state.leaderObj = []),
      (state.profileupdated = false);
    state.donelresults = false;
    state.upschedulesfetched = false;
    state.pastschedulesfetched = false;
    state.overallgraphfetched = false;
    state.subjectgraphfetched = false;
    state.maxiresultfetched = false;
    state.miniresultfetched = false;
  }
};

export const actions = {
  getminiresults({ commit, rootState }) {
    commit("EMPTY_MINI_RESULT");
    let email = rootState.loginmaster.details.email;

    return dashboardservice.miniResults(email).then(response => {
      commit("SET_MINI_RESULTS", response.data);
    });
  },
  getmaxiresults({ commit, rootState }, page, perPage) {
    commit("EMPTY_MAXI_RESULT");
    let email = rootState.loginmaster.details.email;

    return dashboardservice.maxiResults(email, page, perPage).then(response => {
      commit("SET_MAXI_RESULTS", []);

      return response
    });
  },
  addSchedule({ commit }, scheduleObj) {
    return dashboardservice.addSchedules(scheduleObj).then(response => {
      commit("SET_SCHEDULE_ADDED");
      return response;
    });
  },
  upSchedules({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;

    return dashboardservice.upSchedule(email).then(response => {
      commit("SET_UP_SCHEDULES", response.data);
    });
  },
  pastSchedules({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;

    return dashboardservice.pastSchedule(email).then(response => {
      commit("SET_PAST_SCHEDULES", response.data);
    });
  },
  overallGraph({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;

    return dashboardservice.getOverallGraph(email).then(response => {
      commit("SET_OVERALL_GRAPH", response.data);
    });
  },
  subjectGraph({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;

    return dashboardservice.getSubjectGraph(email).then(response => {
      commit("SET_SUBJECT_GRAPH", response.data);
    });
  },
  retrieveLeaderboard({ commit }, query) {
    return dashboardservice.getLeaderboard(query).then(response => {
      commit("SET_LEADERBOARD", response.data);

      return response;
    });
  },
  retrieveLeaderboardI({ commit, rootState }) {
    if (rootState.loginmaster.details.plan == "Premium") {
      let institution = [];
      let allinsti = rootState.loginmaster.details.premium_details.institutions;

      for (let insti of allinsti) {
        institution.push(insti.text);
      }
      institution.shift();
      return dashboardservice.getLeaderboardI(institution).then(response => {
        commit("SET_LEADERBOARDI", response.data);
      });
    }
  },

  saveUserProfile({ commit }, profileObj) {
    return dashboardservice.saveProfile(profileObj).then(() => {
      commit("SET_PROFILE_UPDATED");
    });
  },
  
  logOut({ commit }) {
    commit("DESTROY_ALL");
  },

  retrieveTestspaces({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;
    return dashboardservice.getTestspaces(email).then(response => {
      commit("SET_ORGANIZATION_SPACES", response.data);
    });
  },
  retrieveOrgCandidateTestspaces({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;
    let candidate_id = rootState.loginmaster.details.candidate_id;
    let organization_id = rootState.loginmaster.details.org_details.track_id;
    return dashboardservice
      .getOrgCandidateTestspaces(email, candidate_id, organization_id)
      .then(response => {
        commit("SET_ORGANIZATION_SPACES", response.data);
        return response;
      });
  },
  fetchTestspace({ commit }, codeObj) {
    return dashboardservice.getTestspace(codeObj.codeObj).then(response => {
      commit("SET_SINGLE_TEST_SPACE", {});

      return response;
    });
  },
  emptyTestspace({ commit }) {
    commit("SET_SINGLE_TEST_SPACE", {})
  },
  retrieveCompetitions({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;
    return dashboardservice.getCompetitions(email).then(response => {
      commit("SET_ORGANIZATION_SPACES", response.data);
    });
  },
  fetchCompetition({ commit }, codeObj) {
    return dashboardservice.getCompetition(codeObj.codeObj).then(response => {
      commit("SET_SINGLE_TEST_SPACE", response.data);
    });
  },
  fetchPremiumplans({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;
    commit("FETCHINGPP");
    return dashboardservice.getPremiumplans(email).then(response => {
      commit("FETCHINGPP");
      commit("SET_PREMIUM_PLANS", response.data);
    });
  },
  setRenew({ commit }, trackid) {
    return dashboardservice.onRenew(trackid).then(() => {
      commit("SET_UNSET");
    });
  },
  unsetRenew({ commit }, trackid) {
    return dashboardservice.offRenew(trackid).then(() => {
      commit("SET_UNSET");
    });
  },
  fetchAmbstat({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;

    return dashboardservice.getAmbStat(email).then(response => {
      commit("AMB_STAT", response.data);
    });
  },
  updateAmb({ commit, dispatch }, updateObj) {
    return dashboardservice.setAmb(updateObj).then(() => {
      dispatch("loginmaster/updateDetails", null, {
        root: true
      });
      commit("AMB_UPDATED");
    });
  },
  updateAmbacct({ commit, dispatch }, updateObj) {
    return dashboardservice.setAmbacct(updateObj).then(() => {
      dispatch("loginmaster/updateDetails", null, {
        root: true
      });
      commit("AMB_UPDATED");
    });
  },
  requestPayout({ commit }, reqObj) {
    return dashboardservice.setreqPayout(reqObj).then(() => {
      commit("PAYOUT_REQUESTED");
    });
  },
  cancelPayout({ commit }, cancelObj) {
    return dashboardservice.setCancelpayout(cancelObj).then(() => {
      commit("AMB_UPDATED");
    });
  },
  fetchUsermetrics({ commit, rootState }, limit) {
    let trackid = rootState.loginmaster.details.trackid;

    state.usermetrics = [];

    return dashboardservice.getUsermetrics(trackid, limit).then(response => {
      commit("USER_METRICS_FULL", {})
      
      return response;
    });
  },
  fetchReferrals({ commit, rootState }) {
    let email = rootState.loginmaster.details.email;

    return dashboardservice.getReferrals(email).then(response => {
      commit("SET_REFERRALS", response.data.data);
    });
  },

  fetchNotifications({ commit }) {
    return dashboardservice.getNotifications().then(response => {
      commit("SET_NOTIFICATIONS", response.data.data);
    });
  },
  fetchNotification({ commit }, id) {
    return dashboardservice.getSingleNotification(id).then(response => {
      commit("SET_UNSET");
      return response;
    });
  },
  setNotiReaders({ commit }, noti) {
    return dashboardservice.updateNotiReaders(noti).then(() => {
      commit("SET_UNSET");
    });
  },
  fetchOrgLatestScores({ commit, rootState }) {
    let org_id = rootState.loginmaster.details.org_details.track_id;
    return dashboardservice.getOrgLatestScores(org_id).then(response => {
      commit("SET_UNSET");
      return response;
    });
  },
  fetchOrgUpcomingOngoingTestspaces({ commit, rootState }) {
    let org_id = rootState.loginmaster.details.org_details.track_id;
    return dashboardservice
      .getOrgUpcomingOngoingTestspaces(org_id)
      .then(response => {
        commit("SET_UNSET");
        return response;
      });
  },
  fetchStudySuggestion({ commit, rootState }) {
    let user_id = rootState.loginmaster.details.trackid;
    return dashboardservice.getStudySuggestion(user_id).then(response => {
      commit("SET_UNSET");
      return response;
    });
  },
  fetchStudyNote({ commit}, payload) {
    return dashboardservice.getStudyNote(payload).then(response => {
      commit("SET_UNSET");
      return response;
    });
  
  },
  fetchSingleStudyRoom({ commit}, id) {
    return dashboardservice.getSingleStudyRoom(id).then(response => {
      commit("SET_UNSET");
      return response;
    });
  },
  deleteSingleStudyRoom({ commit}, id) {
    return dashboardservice.deleteSingleStudyRoom(id).then(response => {
      commit("SET_UNSET");
      return response;
    });
  },


  fetchStudyHistory({ commit, rootState }) {
    let user_id = rootState.loginmaster.details.trackid;
    return dashboardservice.getStudyHistory(user_id).then(response => {
      commit("SET_UNSET");
      return response;
    });
  },
  setAppVisit({ commit }) {
    commit("SET_APP_LANDING_VISIT");
  },
};

export const getters = {};
